<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<h2 class="h2b"><a id="page_1"></a><a id="frontmatter02"></a><em>Prologue</em></h2>
<h2 class="h2c"><em>The Gate of Ivory</em></h2>
<p class="linespace"> </p>
<p class="para">Although he knew many songs, he was famed for only one. Once that song had been his alone; now many sang it, but that did not matter to him. The song only he could sing truly remained his. No matter what else he sang, no matter how late the night grew, never would men or women—and as he grew older, he preferred to sing to the women—release him until he had sung that tale.</p>
<p class="indent-para">Always different, suited to the hearts and minds of his audience. Always the same, in the end.</p>
<p class="indent-para">And as the stars burned overhead, he would yield to those who listened, Hebrew or Philistine or strangers upon the endless road.</p>
<p class="indent-para">“Listen and hear of the deeds of Samson, strong and bold. A man who slew many men, a man whom many women desired. A man who loved a woman named Delilah, a woman who brought him low. A woman who gave Samson into the hands of his enemies—”</p>
<p class="indent-para">And men or women, Hebrew or Philistine or stranger, they listened. For everyone had heard tales of Samson, and many knew that only Orev could offer them the truth. Had he not walked beside Samson, and seen with his own eyes the wonders he now sang to them?</p>
<p class="indent-para">Sometimes, as he sang, Orev marveled at his own tales. That golden time seemed long ago and far away now, and truth elusive as a ghost . . .</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?cec486de